var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSideMenu = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.6,460.5h333.2c18.2,0,33-14.8,33-33V94.3c0-18.2-14.8-33-33-33H83.6c-18.2,0-33,14.8-33,33v333.2 C50.6,445.7,65.4,460.5,83.6,460.5z M226.2,331.8l-57-57l57.8-57.8l-0.2,33c46.4-11.9,77.8-50.4,79.9-99.1c0.1-2.7,1.1-3.2,3.5-3.2 c6.5,0.1,12.9,0,19.4,0c6.3,0,12.7,0.2,19-0.1c3.3-0.1,4.2,1.1,3.9,4.2c-0.4,4.4-0.4,8.8-0.9,13.1c-5.7,44.5-26.6,80.1-63.1,106.3 c-18.9,13.6-39.7,22-62.1,25.7L226.2,331.8z M79.6,427.7V104.8h25.2c17.2,0,31.2,14,31.2,31.2v260.5c0,17.2-14,31.2-31.2,31.2H79.6z "
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSideMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/side_menu.ff9f81f3.svg";
export { ForwardRef as ReactComponent };